import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '400px',
  },
}));

function getUnidades(data) {
  const unidades = data.unidades_caixa_aparente
    ? data.unidades_caixa_aparente
    : data.unidades_caixa
    ? data.unidades / data.unidades_caixa
    : data.unidades;

  return unidades;
}

const UnidadesField = (props) => {
  const classes = useStyles();

  const record = useRecordContext(props);
  const value = record ? getUnidades(record.record) : '';

  return <Typography className={classes.text}>{value}</Typography>;
};

export default UnidadesField;
